import { Table, Spin, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import deleteIcon from "../../../../../Assets/svg/table-action-delete.svg";
import editIcon from "../../../../../Assets/svg/table-action-edit.svg";
import previewIcon from "../../../../../Assets/svg/table-action-preview.svg";
import DeleteComponent from "../../../../components/DeleteComponent/DeleteComponent";
import EditSiteVisitCardModal from "../Modals/EditSiteVisitCardModal";
import DuplicateSiteVisitCardModal from "../Modals/DuplicateSiteVisitCardModal";
import Preview from "./modals/Preview";
import Filters from "../Filters";
import { httpService } from "../../../../../services/httpService.service";
import MessagePopUp from "../../../../components/Messages/MessagePopUp";
import { RolesEnum } from "../../../../../services/rolesEnum";
import { isAuthorized } from "../../../../../services/authService";
import duplicateIcon from "../../../../../Assets/svg/duplicateIcon.svg";
import exclamationMark from "../../../../../Assets/svg/exclamationMark.svg";
import moveIcon from "../../../../../Assets/svg/moveIcon.svg";
import done from "../../../../../Assets/svg/done.svg";
import "./styles.scss";
import { getSiteVisitStatus } from "../../../../../services/Enums/siteVisitStatusEnum";
import MoveSiteVisitModal from "./modals/MoveSiteVisitModal";
import FacilityTag from "../../../../components/FacilityTag/FacilityTag";
import StalledPill from "../../../../components/StalledPill/StalledPill";
import {
  orderSiteVisitColumns,
  siteVisitPersonName as coordinatorName,
} from "../../../../components/SiteVisitColumns/siteVisitColumnOrder";
import { useColumnSizing } from "../../../../components/SiteVisitColumns/useColumnSizing";

function TableView({
  siteVisitCards,
  fetchSiteVisitCards,
  loading,
  setLoading,
  onPageChange,
  pagination,
  setPagination,
  onOk,
  onRowSelectionChange,
  filters,
  setFilters,
  totalVisits,
}) {
  //Handle Modals
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedSiteVisit, setSelectedSiteVisit] = useState(null);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [showMoveModal, setShowMoveModal] = useState(false);

  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [inputSearch, setInputSearch] = useState(filters.Search);

  const handleToggleEditModal = (record) => {
    const siteVisitCardId = record?.id;
    setSelectedSiteVisit(siteVisitCardId);
    setShowEditModal(!showEditModal);
  };

  const handleTogglePreviewModal = (record) => {
    const siteVisitCardId = record?.id;
    setSelectedSiteVisit(siteVisitCardId);
    setShowPreviewModal(!showPreviewModal);
  };
  const [recordToDelete, setRecordToDelete] = useState();

  const handleDelete = (record) => {
    const siteVisitId = record.id;
    setRecordToDelete(siteVisitId);
    setShowDeleteModal(true);
  };

  const handleDuplicate = (record) => {
    setCurrentRecord(record?.id);
    setShowDuplicateModal(true);
  };

  const onDuplicated = () => {
    setShowDuplicateModal(false);
    setCurrentRecord(null);
    fetchSiteVisitCards();
  };

  const onEdited = () => {
    setShowEditModal(false);
    onOk();
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    if (recordToDelete) {
      const requestBody = [
        {
          id: recordToDelete,
          isDeleted: false,
        },
      ];

      const url = `/api/Site/deleteSiteVisits?includeIsDeleted=false`;
      httpService.delete(
        url,
        JSON.stringify(requestBody),
        (response) => {
          const message = response.message;
          setMessage({
            trigger: true,
            type: "success",
            icon: done,
            title: "Site visit card created successfully!",
            text:
              message ||
              "You have successfully deleted this site visit. You can revert it from deleted cards.",
          });
          setTimeout(() => {
            setMessage({
              trigger: false,
            });
          }, 3000);
          fetchSiteVisitCards();
          setShowDeleteModal(false);
          setLoading(false);
        },
        (error) => {
          const errorMessage =
            error?.errors?.[0]?.message ||
            error?.message ||
            "Error deleting record.";
          console.error("Error deleting record:", error);

          setMessage({
            trigger: true,
            type: "danger",
            icon: exclamationMark,
            title: "Oops! A problem has occurred!",
            text: errorMessage || "Failed to delete the record.",
          });
          setTimeout(() => {
            setMessage({
              trigger: false,
            });
          }, 3000);
          setLoading(false);
        }
      );

      setRecordToDelete(null);
    }
  };

  const handleFiltersChange = (newFilters) => {
    setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
    setPagination({ ...pagination, current: 1 });
  };

  useEffect(() => {
    fetchSiteVisitCards();
  }, []);

  function isUUID(str) {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
  }

  const itemToPreview = localStorage.getItem("entityId");
  useEffect(() => {
    if (itemToPreview && isUUID(itemToPreview)) {
      setSelectedSiteVisit(itemToPreview);
      setShowPreviewModal(!showPreviewModal);
      setTimeout(() => {
        localStorage.setItem("entityId", "");
      }, 300);
    }
  }, [itemToPreview]);

  const columns = [
    {
      title: <span className="styledTitle">Site Visit Identifier</span>,
      sorter: (a, b) => a.identifier.localeCompare(b.identifier),
      dataIndex: "identifier",
      key: "siteVisitIdentifier",
      render: (text, record) => (
        <Tooltip title={text}>
          <span className="styledDataIndex3">{text}</span>
        </Tooltip>
      ),
    },
    {
      title: <span className="styledTitle">Site Visit Name</span>,
      sorter: (a, b) => a.name.localeCompare(b.name),
      dataIndex: "name", // Raw field for identifier
      key: "name",
      // F-03 — the stalled flag rides along with the name so the escalation
      // marker is visible without moving the status/target-date columns.
      render: (text, record) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          <span className="styledDataIndex3">{text}</span>
          {record?.isStalled && (
            <StalledPill stalledSince={record?.stalledSince} />
          )}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Site Visit Status</span>,
      sorter: (a, b) => a.siteVisitStatus.localeCompare(b.siteVisitStatus),
      dataIndex: "siteVisitStatus",
      key: "siteVisitStatus",
      render: (text) => {
        const status = getSiteVisitStatus(text);
        return (
          <div className={`${status.className} m-0`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8px"
              height="8px"
              viewBox="0 0 9 9"
            >
              <circle cx="4.5" cy="4.27344" r="4" fill={status.fill} />
            </svg>
            <span>{status.text}</span>
          </div>
        );
      },
    },
    {
      title: <span className="styledTitle">Date of Target Visit</span>,
      sorter: (a, b) =>
        a.visit?.plannedVisit?.localeCompare(b.visit?.plannedVisit),
      key: "dateOfPlannedVisit",
      render: (text, record) => (
        <span className="styledDataIndex3">{record.visit?.plannedVisit}</span> // Accessing via record
      ),
    },
    {
      title: <span className="styledTitle">Facility</span>,
      dataIndex: "facility",
      key: "facility",
      ellipsis: true,
      width: 250,
      sorter: (a, b) =>
        (a.facility?.name || "").localeCompare(b.facility?.name || ""),
      render: (facility) => <FacilityTag facility={facility} />,
    },

    {
      title: <span className="styledTitle">IP</span>,
      sorter: (a, b) =>
        a.ipPlan?.implementingPartner?.name.localeCompare(
          b.ipPlan?.implementingPartner?.name
        ),
      key: "ip",
      render: (text, record) => (
        <span className="styledDataIndex3">
          {record.ipPlan?.implementingPartner?.name}
        </span>
      ),
    },

    {
      title: <span className="styledTitle">Location</span>,
      sorter: (a, b) =>
        a.locationDetails?.country.localeCompare(b.locationDetails?.country),
      key: "location",
      render: (text, record) => (
        <span className="styledDataIndex3">
          {record.locationDetails?.country}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Governate/State</span>,
      sorter: (a, b) => a.siteVisitName.localeCompare(b.siteVisitName),
      dataIndex: "state",
      key: "state",
      render: (text, record) => (
        <span className="styledDataIndex3">
          {record?.locationDetails?.state || "This country has no states."}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Cluster</span>,
      sorter: (a, b) => a.cluster?.name.localeCompare(b.cluster?.name),
      key: "cluster",
      render: (text, record) => (
        <span className="styledDataIndex3">{record.cluster?.name}</span>
      ),
    },
    {
      title: <span className="styledTitle">Virtual</span>,
      sorter: (a, b) => a.isVirtual.localeCompare(b.isVirtual),
      key: "virtual",
      render: (text, record) => (
        <span className="styledDataIndex3">
          {record.isVirtual ? "Yes" : "No"}
        </span>
      ),
    },
    // Coordinator and team are decided during planning, so the board that plans
    // them now shows them — they were previously only visible once the visit
    // reached the reporting boards.
    {
      title: <span className="styledTitle">TPM Coordinator</span>,
      key: "tpmCoordinator",
      sorter: (a, b) =>
        coordinatorName(a?.logistic?.tpmCoordinator).localeCompare(
          coordinatorName(b?.logistic?.tpmCoordinator)
        ),
      render: (text, record) => (
        <span className="styledDataIndex3">
          {coordinatorName(record?.logistic?.tpmCoordinator) || "—"}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Team</span>,
      key: "team",
      sorter: (a, b) =>
        (a?.logistic?.team?.name || "").localeCompare(
          b?.logistic?.team?.name || ""
        ),
      render: (text, record) => (
        <span className="styledDataIndex3">
          {record?.logistic?.team?.name || "—"}
        </span>
      ),
    },
    {
      title: <span className="styledTitle"></span>,
      key: "action",
      fixed: isLargeScreen && siteVisitCards.length > 0 ? "right" : undefined,

      render: (text, record) => (
        <div className="actionDiv">
          {isAuthorized([
            RolesEnum.ProjectManager,
            RolesEnum.SystemAdmin,
            RolesEnum.FieldLogistics,
          ]) && (
            <Tooltip title="Move site visit">
              <img
                src={moveIcon}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedSiteVisit(record);
                  setShowMoveModal(true);
                }}
                loading={loading}
                setMessage={setMessage}
              ></img>
            </Tooltip>
          )}
          {isAuthorized([
            RolesEnum.ProjectManager,
            RolesEnum.SystemAdmin,
            RolesEnum.FieldCoordinator,
            RolesEnum.FieldLogistics,
            RolesEnum.DataAnalyst,
          ]) && (
            <Tooltip title="Duplicate site visit">
              <img
                src={duplicateIcon}
                style={{ cursor: "pointer" }}
                onClick={() => handleDuplicate(record)}
                loading={loading}
                setMessage={setMessage}
              ></img>
            </Tooltip>
          )}
          {isAuthorized([
            RolesEnum.ProjectManager,
            RolesEnum.SystemAdmin,
            RolesEnum.FieldCoordinator,
            RolesEnum.FieldTeamLeader,
            RolesEnum.FieldEnumerator,
            RolesEnum.FieldLogistics,
            RolesEnum.Guest,
            RolesEnum.DataAnalyst,
            RolesEnum.LimitedGuest,
          ]) && (
            <Tooltip title="Preview site visit">
              <img
                src={previewIcon}
                onClick={() => handleTogglePreviewModal(record)}
                style={{ cursor: "pointer" }}
              ></img>
            </Tooltip>
          )}
          {isAuthorized([
            RolesEnum.ProjectManager,
            RolesEnum.SystemAdmin,
            RolesEnum.FieldCoordinator,
            RolesEnum.FieldTeamLeader,
            RolesEnum.FieldLogistics,
            RolesEnum.DataAnalyst,
          ]) && (
            <Tooltip title="Edit site visit">
              <img
                src={editIcon}
                onClick={() => handleToggleEditModal(record)}
                style={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}
          {isAuthorized([RolesEnum.ProjectManager, RolesEnum.SystemAdmin]) && (
            <Tooltip title="Delete site visit">
              <img
                src={deleteIcon}
                style={{ cursor: "pointer" }}
                onClick={() => handleDelete(record)}
              ></img>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  // Planning is where the whole card is set up, so nothing is collapsed here —
  // this is the table that shows every planning field. `orderSiteVisitColumns`
  // is still applied so the sequence is provably the same one the later tables
  // follow rather than one that happens to match today.
  // Column widths and folded columns are still per-user here, same as every
  // other site-visit table.
  const {
    columns: orderedColumns,
    components: tableComponents,
    sizingBar,
  } = useColumnSizing({
    tableId: "planningVisits",
    columns: orderSiteVisitColumns(columns),
  });

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      onRowSelectionChange(selectedRowKeys);
    },
  };

  return (
    <>
      <Filters
        onFiltersChange={handleFiltersChange}
        filters={filters}
        setFilters={setFilters}
        pagination={pagination}
        setPagination={setPagination}
        setInputSearch={setInputSearch}
        inputSearch={inputSearch}
      />
      <div
        className="w-100 my-3 d-flex justify-content-start gap-2"
        style={{
          color: "var(--2, #AA1A5F)",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "24px",
        }}
      >
        {loading ? (
          <Spin className="me-2" size="small" spinning={loading} />
        ) : (
          `Total: ${totalVisits} visits`
        )}
        {sizingBar && <span className="ms-auto">{sizingBar}</span>}
      </div>

      <div>
        <Table
          components={tableComponents}
          rowKey="id"
          loading={loading}
          rowSelection={siteVisitCards.length > 0 ? { ...rowSelection } : ""}
          dataSource={siteVisitCards}
          columns={siteVisitCards?.length > 0 ? orderedColumns : []}
          pagination={{
            ...pagination,
            onChange: onPageChange,
          }}
          className="tableTPM"
          scroll={{ x: "max-content" }}
        />
      </div>
      <EditSiteVisitCardModal
        onOk={onEdited}
        visible={showEditModal}
        onCancel={handleToggleEditModal}
        siteVisitCardId={selectedSiteVisit}
        setMessage={setMessage}
        allowEditStatus={false}
      />
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <DuplicateSiteVisitCardModal
        visible={showDuplicateModal}
        siteVisitCardId={currentRecord}
        onCancel={() => setShowDuplicateModal(false)}
        onOk={onDuplicated}
        setMessage={setMessage}
      />
      <Preview
        visible={showPreviewModal}
        onClose={handleTogglePreviewModal}
        siteVisitCardId={selectedSiteVisit}
      />
      <DeleteComponent
        visible={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        text={
          "You're about to delete this site visit card. You can return it back from the deleted cards later! "
        }
        header={"Delete "}
        onConfirm={handleConfirmDelete}
        loading={loading}
      />
      <MoveSiteVisitModal
        visible={showMoveModal}
        siteVisit={selectedSiteVisit}
        onClose={() => setShowMoveModal(false)}
        onSubmit={() => {
          setShowMoveModal(false);
          fetchSiteVisitCards();
        }}
        setMessage={setMessage}
      />
    </>
  );
}

export default TableView;
